const anchors = document.querySelectorAll('.anchor-link');

function getId(link) {
  return link.getAttribute('href').replace('#', '');
}

anchors.forEach((element) => {
  element.addEventListener('click', (event) => {
    event.preventDefault();
    const target = event.target.closest('a[href^="#"]');
    const targetSection = document.getElementById(getId(target));
    window.scrollTo({
      top: targetSection.offsetTop,
      behavior: 'smooth',
    });
  });
});
